<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 230px">
        <p>所属公司：</p>
        <el-select v-model="companyIpt" filterable size="mini" style="width:150px" placeholder="请选择">
          <el-option v-for="item in companyOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navContainer" style="width: 210px">
        <p>手机号：</p>
        <el-input v-model="tellIpt" size="mini" style="width:150px" placeholder="请输入手机号"/>
      </div>
      <div class="navContainer">
        <p>姓名：</p>
        <el-input v-model="nameIpt" size="mini" style="width:150px" placeholder="请输入姓名"/>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">新增</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
           :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label="序号" align="center" width="50px">
            <div slot-scope="scope">{{scope.$index+1}}</div>
          </el-table-column>
          <el-table-column prop="company" label="所属公司" align="center"/>
          <el-table-column prop="tell" label="手机号" align="center"/>
          <el-table-column prop="name" label="姓名" align="center"/>
          <el-table-column prop="sex" label="性别" align="center"/>
          <el-table-column prop="state" label="状态" align="center"/>
          <el-table-column label="操作" width="210" align="center">
            <template slot-scope="scope">
              <div>
                <el-button v-if="scope.row.state==='启用中'" size="mini" type="danger" @click="disableClick(scope.$index, scope.row)">禁用</el-button>
                <el-button v-else size="mini" type="primary" @click="enableClick(scope.$index, scope.row)">启用</el-button>
                <el-button size="mini" type="primary" @click="detailClick(scope.$index, scope.row)" class="searchBtn">详情</el-button>
                <el-button size="mini" type="info" @click="deleteClick(scope.$index, scope.row)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width='550px' center @close="dialogClose" :close-on-click-modal="false">
      <div class="company">
        <el-form :model="operationData" label-width="110px" :rules="rules" ref="ruleForm">
          <div-border label="选择调度人员" prop="scheduler">
            <el-form-item label="选择人员：" prop="name" style="margin-top: 15px;margin-bottom: 0">
              <el-select v-model="operationData.name" filterable size="mini" style="width:100%" placeholder="请选择调度人员" value-key="key">
                <el-option v-for="item in nameOption" :key="item.label" :label="item.label" :value="item"/>
              </el-select>
            </el-form-item>
            <el-form-item label="所属公司：" style="margin-bottom: 0;">
              <span v-if="operationData.name">{{operationData.name.value}}</span>
            </el-form-item>
            <el-form-item label="电话号码：" style="margin-bottom: 0;">
              <span v-if="operationData.name">{{operationData.name.tell}}</span>
            </el-form-item>
            <el-form-item label="性别：" style="margin-bottom: 0;">
              <span v-if="operationData.name">{{operationData.name.sex}}</span>
            </el-form-item>
          </div-border>
        </el-form>
        <div class="btnContainer">
          <el-button size="medium" class="searchBtn" :loading="addLoad" @click="addClick">确定</el-button>
          <el-button size="medium" class="resetBtn" @click="dialogClose">关闭</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="运营调度人员详情" :visible.sync="detailDialogVisible" width='550px' center>
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
            <p>{{detailData.state}}</p>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">用户姓名：</span>
              <span>{{detailData.name}}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">手机号：</span>
                <span>{{detailData.tell}}</span>
              </div>
              <div>
                <span class="span1">邮箱：</span>
                <span>{{detailData.mail}}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">性别：</span>
                <span>{{detailData.sex}}</span>
              </div>
              <div>
                <span class="span1">年龄：</span>
                <span>{{detailData.age}}</span>
              </div>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">所属公司：</span>
              <span>{{detailData.company}}</span>
            </div>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line"/>
            <span>操作信息</span>
          </div>
          <div class="operationTable">
            <el-table :data="operationData1" border>
              <el-table-column prop="operateTime" label="操作时间" align="center" width="160px"/>
              <el-table-column prop="operateType" label="操作类型" align="center"/>
              <el-table-column prop="account" label="操作人" align="center"/>
              <el-table-column prop="remark" label="备注" align="center"/>
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import divBorder from "@/components/divBorder";

export default {
  components: {
    divBorder
  },

  data() {
    return {
      companyIpt:0,
      tellIpt:'',
      nameIpt:'',
      companyOption:[
        {value:0,label:'全部'},
        // {value:'民生物流(xx)分公司1',label:'民生物流(xx)分公司1'},
        // {value:'民生物流(xx)分公司2',label:'民生物流(xx)分公司2'},
        // {value:'民生物流(xx)分公司3',label:'民生物流(xx)分公司3'},
      ],
      TableDatas:[
        // {company:'民生物流(xx)分公司1',name:'张三丰',tell:'17700000000',state:'启用中',sex:'男'},
        // {company:'民生物流(xx)分公司2',name:'万马仕',tell:'17700000000',state:'启用中',sex:'男'},
        // {company:'民生物流(xx)分公司3',name:'谢琴',tell:'17700000000',state:'禁用中',sex:'男'},
      ],
      page:1,
      size:10,
      total:0,
      tableLoad:false,
      dialogVisible:false,
      addLoad:false,
      dialogTitle:'',
      operationData:{},
      rules:{
        scheduler:[
          { required: true, message: ' ', trigger: 'change' },
        ],
        name:[
          { required: true, message: '请选择调度人员', trigger: 'change' },
        ],
      },
      nameOption:[
        {value:'民生物流(xx)分公司1',label:'张三',tell:'17751553546',sex:'男',key:'01'},
        {value:'民生物流(xx)分公司2',label:'周世鹏',tell:'17751553546',sex:'男',key:'02'},
        {value:'民生物流(xx)分公司3',label:'李四',tell:'17751553546',sex:'男',key:'03'},
      ],
      detailDialogVisible:false,
      detailData:{
        company:'民生物流(xx)分公司1',
        name:'张三',
        tell:'17755550000',
        mail:'543554868@qq.com',
        sex:'男',
        age:'20',
      },
      operationData1:[
        {operateTime:'2021-8-31 15:49:58',operateType:'启用',account:'王三文',remark:''},
        {operateTime:'2021-8-31 15:49:58',operateType:'禁用',account:'张三丰',remark:''},
        {operateTime:'2021-8-31 15:49:58',operateType:'添加',account:'赵兮雪',remark:''},
      ],
    };
  },
  methods: {
    resetBtn(){
      this.companyIpt=0;
      this.tellIpt='';
      this.nameIpt='';
    },
    addClick(){
      this.$refs.ruleForm.validate((valid,val) => {
        // if(Object.keys(val).length === 1) valid=true;
        if (valid) {
          this.addLoad = true;
          this.addLoad = false;
          this.dialogVisible=false;
        } else {
          return false;
        }
      });
    },
    searchBtn(){
      this.page = 1;
      },
    addBtn(){
      this.dialogVisible=true;
      this.dialogTitle='添加运营调度';
    },
    dialogClose(){
      this.dialogVisible=false;
      this.operationData={};
      this.$refs.ruleForm.resetFields();
    },
    contractSizeChange(sizes){
      this.size=sizes;
    },
    contractCurrentChange(page){
      this.page=page;
    },
    detailClick(){
      this.detailDialogVisible=true;
    },
    deleteClick(){
      this.$confirm('确定要删除当前运营调度人员吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
      }).catch(() => {});
    },
    disableClick(){
      this.$confirm('确定要禁用当前运营调度人员吗！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
      }).catch(() => {});
    },
    enableClick(){
      this.$confirm('确定要启用当前运营调度人员吗！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
      }).catch(() => {});
    },
  },
};
</script>



<style lang="scss" scoped>
.mainContainer {
  width: 100%;
  padding: 20px 15px 0 25px;
  background-color: #fff;
  .line{
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }
  .line +span{
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }
  .btnContainer{
    width:100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px 0 5px 0;
    button{
      margin: 0 15px;
    }
  }
  .nav{
    width:100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &Container{
      width:200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;
      p{
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }
    &Btn{
      margin-bottom: 5px;
      display: flex;
      align-items: center;
    }
    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    .tableContainer{
      margin-top: 30px;
      margin-bottom: 25px;
      width: 100%;
      ::v-deep{
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
        .el-table th>.cell{
          font-weight: 700!important;
        }
      }
    }
    .paginationContainer{
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span{
        font-size: 13px;
      }
    }
  }
  .company{
    width:100%;
    padding: 20px 10px 10px 10px;
    .transport{
      width:100%;
      border: 1px solid #C3C3C3;
      position:relative;
      padding:0 10px;
      margin-bottom: 20px;
      &Title{
        margin-bottom: 0;
        position:absolute;
        top: -21px;
        z-index: 999;
        background-color: #fff;
        left:20px;
        padding-right:10px;
        color: rgb(51, 84, 131);
        font-size: 15px;
        font-weight:700;
        ::v-deep{
          .el-form-item__label{
            color: rgb(51, 84, 131);
            font-size: 15px;
          }
        }
      }
    }
    .productTable{
      margin-top:15px;
      ::v-deep{
        .el-input--mini .el-input__inner{
          width: 100%;
        }
        .cell{
          font-size: 10px;
          padding:0;
        }
        .el-table td, .el-table th{
          padding:0;
        }
      }
      .tableAddBtnContainer{
        border: 1px solid #EBEEF5;;
        border-top-style: none;
        width: 100%;
        height: 35px;
        display: flex;
        align-items: center;
        padding-left: 15px;
        .AddContainer{
          display: flex;
          align-items: center;
          &:hover{
            cursor: pointer;
          }
        }
        img{
          object-fit: cover;
          margin-right: 5px;
        }
        p{
          font-size: 13px;
          color: #F59A23;
          font-family: 'Arial Normal', 'Arial', sans-serif;
        }
      }
    }
    .update{
      font-size: 14px;
      color: rgba(51, 136, 255, 1);
      text-decoration: underline;
    }
    ::v-deep{
      .el-form-item__label{
        font-weight: 700;
      }
      .el-form-item__label{
        padding:0;
      }
      .el-form-item{
        margin-bottom:15px;
      }
      .el-form-item__content{
        position: relative;
      }
    }
    hr{
      margin: 0;
      position: absolute;
      width: 100%;
      bottom: 5px;
    }
  }
  .detail{
    width: 100%;
    padding: 10px 0 20px 20px;
    .baseInfo{
      display: flex;
      flex-direction: column;
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Content{
        display:flex;
        flex-direction: column;
        justify-content: space-between;
        padding:20px 23px 0 23px;
        &Item{
          margin-bottom: 20px;
          span{
            color: rgba(16, 16, 16, 100);
            font-size: 14px;
          }
          .specialOne{
            width:50%;
          }
        }
        .specialItem{
          display:flex;
        }
      }
    }
    .operation{
      display: flex;
      flex-direction: column;
      ::v-deep{
        .el-table td, .el-table th{
          padding:0;
        }
        .cell{
          font-size: 10px;
          padding:0;
        }
      }
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Table{
        width:100%;
        margin-top: 10px;
        padding: 0 20px;
      }
    }
  }
  ::v-deep{
    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }
    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }
    .el-dialog__headerbtn{
      top:9px;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }
    .el-dialog__body {
      padding: 0;
    }
  }
}
</style>
